import { resetShowResults } from '~teacher/components/ResultsGrid/atoms/useShowResults';

import { resetScoreDisplay } from './useScoreDisplay';
import { resetShowNames } from './useShowNames';
import { resetShowResponses } from './useShowResponses';
import { resetShowTimers } from './useShowTimers';

export function resetResultsToggles() {
  resetScoreDisplay();
  resetShowNames();
  resetShowResults();
  resetShowResponses();
  resetShowTimers();
}
